module.exports = __webpack_public_path__ + "img/bootstrap4-dark-purple.39977b6a.svg";